import debounce from 'lodash.debounce';
import GallerySection from '../acf-blocks/gallery-section';
import ContactBoxes from '../modules/contact-boxes';
import EquipmentCardsSection from '../modules/equipment-cards';
import FAQSection from '../modules/faq-section';
import BaseFilter from '../modules/filters/baseFilter';
import Gallery from '../modules/gallery';
import MapContactPersons from '../modules/map-contact-boxes';
import OfferListSection from '../modules/offer-list';
import TeamSection from '../modules/team-section';
import VideoSection from '../modules/video-section';
import InitContactBox from './contact-box';
import initCtaSection from '../modules/cta';
import initIconBoxes from './icon-boxes';
import mobileCarousel from '../utils/mobileCarousel';
import AttachmentSection from './attachments';

export default class PagesContentSection {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;
        this.root = el;
        this.wrapper = this.root.querySelector('[data-pages-content-wrapper]');
        this.baseCategory = this.root.querySelector(
            '[data-pages-content-post-id]'
        );
        this.filter = this.root.querySelectorAll('[data-filter-switcher]');
        this.loader = this.root.querySelector('[data-pages-content-loader]');
        this.gallery = this.root.querySelectorAll('[data-gallery]');
        this.galleries = [];
        this.topButtons = this.root.querySelectorAll(
            '[data-filter-switcher-toggle-dependant]'
        );

        this.noResultsEl = this.root.querySelector(
            '[data-pages-content-no-results]'
        );

        if (this.baseCategory) this.baseCategory = this.baseCategory.value;
        this.filterSwitch = null;

        this.offers = [];
        this.baseFiltersConstructors = [];
        this.currentCategory = this.topButtons
            ? this.topButtons[0].getAttribute('data-filter-switcher-item')
            : null;
        this.masonry = null;
        this.loadOffers = debounce(this.getOffers, 500);

        return true;
    }

    init() {
        this.initFilters();
        this.offerLoader();
    }

    initGallery() {
        if (this.galleries.length) {
            this.galleries.forEach(item => {
                item.swiper.destroy();
            });

            this.galleries = [];
        }

        this.gallery = this.root.querySelectorAll('[data-gallery]');
        this.gallery.forEach(item => {
            this.galleries.push(new Gallery(item));
        });
    }

    initFilters() {
        if (!this.filter) return;

        this.filter.forEach(filter => {
            this.baseFiltersConstructors.push(
                new BaseFilter(filter, this.root)
            );
        });

        this.filterSwitch = this.onFilterSwitch.bind(this);
        this.root.addEventListener('filter-switcher-change', event =>
            this.filterSwitch(event)
        );

        if (
            this.baseFiltersConstructors.length > 0 &&
            this.baseFiltersConstructors[0].items
        ) {
            const activeBaseFilter = this.baseFiltersConstructors[0];
            const { toggleItems } = activeBaseFilter;
            activeBaseFilter.items[0].click();

            /*if (toggleItems.length) {
                const dependantItem = this.baseFiltersConstructors.filter(
                    item => item.dependant === toggleItems[0]
                );

                if (dependantItem.length > 0) dependantItem[0].items[0].click();
            }*/
        }
    }

    offerLoader() {
        this.loader.classList.remove('d-none');
        this.loadOffers();
    }

    getOffers() {
        const formData = new FormData();
        formData.append('action', 'offers_list');

        if (this.currentCategory)
            formData.append('category', this.currentCategory);

        jQuery.ajax({
            type: 'POST',
            url: ajax.url,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            data: formData,
            success: function (response) {
                const data = JSON.parse(response);
                const { maxNumPages, html } = data;

                this.maxPages = maxNumPages;
                this.offers = data.data;
                this.wrapper.innerHTML = html;
            }.bind(this),
            error: function () {
                this.offers = [];
            }.bind(this),
            complete: function () {
                this.loader.classList.add('d-none');
                //this.initGallery();
                //this.gridHandler();
                this.setEquipmentCards();
                this.setVideoSections();
                this.setOfferLists();
                this.setContactBoxesSections();
                this.setFaqSection();
                this.setTeamSection();
                this.setMapContactSection();
                this.setGalleriesSections();
                this.setContactBoxAltSection();
                this.setCtaSections();
                this.setIconBoxes();
                this.setColorIconBoxes();
                this.setAttachmentsSection();
            }.bind(this),
        });
    }

    onFilterSwitch(event) {
        const { detail } = event;
        const { value } = detail;

        this.currentCategory = parseInt(value);
        this.offerLoader();
    }

    setEquipmentCards() {
        const sections = this.root.querySelectorAll('[data-equipment-cards]');
        if (!sections) return;
        sections.forEach(section => new EquipmentCardsSection(section));
    }

    setOfferLists() {
        const sections = this.root.querySelectorAll('[data-offer-list]');
        if (!sections) return;
        sections.forEach(section => new OfferListSection(section));
    }

    setVideoSections() {
        const sections = this.root.querySelectorAll('[data-video-section]');
        if (!sections) return;
        sections.forEach(item => new VideoSection(item));
    }

    setContactBoxesSections() {
        const sections = this.root.querySelectorAll('[data-contact-boxes]');
        if (!sections) return;
        sections.forEach(item => new ContactBoxes(item));
    }

    setFaqSection() {
        const sections = this.root.querySelectorAll('[data-faq]');
        if (!sections) return;
        sections.forEach(item => new FAQSection(item));
    }

    setTeamSection() {
        const sections = this.root.querySelectorAll('[data-team-section]');
        if (!sections) return;
        sections.forEach(item => new TeamSection(item));
    }

    setMapContactSection() {
        const sections = this.root.querySelectorAll(
            '[data-map-contact-persons]'
        );
        if (!sections) return;
        sections.forEach(item => new MapContactPersons(item));
    }

    setGalleriesSections() {
        const sections = this.root.querySelectorAll('.gallery-section');
        if (!sections) return;
        sections.forEach(item => new GallerySection(item));
    }

    setCtaSections() {
        const sections = this.root.querySelectorAll('.cta');
        if (!sections) return;
        sections.forEach(item => initCtaSection(item));
    }

    setColorIconBoxes() {
        mobileCarousel('color-icon-boxes__slider', 'swiper-pagination-icon-boxes', 1.1, 0);
    }

    setIconBoxes() {
        initIconBoxes();
    }

    setContactBoxAltSection() {
        InitContactBox();
    }

    setAttachmentsSection() {
        const sections = this.root.querySelectorAll('[data-attachments]');
        if (!sections) return;
        sections.forEach(item => new AttachmentSection(item))
    }
}

const sections = document.querySelectorAll('[data-pages-content]');
const initPagesContentSections = sections => {
    if (sections) {
        sections.forEach(section => new PagesContentSection(section));
    }
};

initPagesContentSections(sections);
